import { HttpClient } from "@angular/common/http";
import { Component, isDevMode, OnInit, Type } from "@angular/core";
import { V4HousesModalSelectComponent } from "@root/router/component/v4/houses-modal-select/houses-modal-select.component";
import { V4RoomTypesModalSelectComponent } from "@root/router/component/v4/room-types-modal-select/room-types-modal-select.component";
import { TranslateService } from "@root/shared/service/translate.service";
import { SharedModule } from "@root/shared/shared.module";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "host-connect-with-tongcheng",
  templateUrl: "./connect-with-tongcheng.component.html",
  styleUrls: ["./connect-with-tongcheng.component.scss"],
})
export class V4ConnectWithTongchengComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;

  step = 1;

  loading = false;

  //#region form
  mobile;
  code;
  thirdpartyAccountId;
  //#endregion
  constructor(
    private t: TranslateService,
    private modal: NzModalService,
    private http: HttpClient,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {}

  onCancel() {
    this.modalRef.destroy();
  }

  onFinish() {
    this.modalRef.destroy();
  }

  onSendVerifyCode() {
    const params = { mobile: this.mobile };
    this.http.post("/api/tongcheng/send_verify_code", params).subscribe((rst: any) => {
      if (isDevMode() || rst.error_code === 0) {
        this.step = 3;
      }
    });
  }

  onAuth() {
    const params = {
      mobile: this.mobile,
      code: this.code,
    };
    this.http.post("/api/tongcheng/auth", params).subscribe((rst: any) => {
      if (isDevMode()) {
        this.step = 4;
        this.thirdpartyAccountId = "12345";
      }
      if (rst.error_code === 0) {
        this.step = 4;
        this.thirdpartyAccountId = rst?.data?.thirdparty_account_id;
      }
    });
  }

  onAddHouses(type: "house" | "type") {
    const cmp: Type<any> = type === "house" ? V4HousesModalSelectComponent : V4RoomTypesModalSelectComponent;
    const modal = this.modal.create({
      // nzTitle: '添加房源',
      nzTitle: this.t.t("thirdhub.pricelabs.operate.btn.add"),
      nzContent: cmp,
      nzWidth: 900,
      nzFooter: null,
    });
    modal.afterClose.subscribe(({ data }) => {
      console.log("after close: ", data);
      if (data) {
        const ids = data?.map((t) => t.value) ?? [];
        if (type === "house") {
          this.requestCreateProperties({ property_ids: ids });
        } else {
          this.requestCreateProperties({ room_type_ids: ids });
        }
      }
    });
  }

  private requestCreateProperties(data: { property_ids?: number[]; room_type_ids?: number[] }) {
    const params = {
      thirdparty_account_id: this.thirdpartyAccountId,
      ...data,
    };
    this.http.post("/api/tongcheng/add_listings", params).subscribe((rst: any) => {
      if (isDevMode() || rst.error_code === 0) {
        this.step = 5;
      }
    });
  }
}
